import { Routes, Route } from "react-router";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

//Views
import ManufacturersMain from 'Modules/manufacturers/views/main';
import ManufacturerOverview from 'Modules/manufacturers/views/overview';

const RouterManufacturers = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "man") && <Route path="list" element={<ManufacturersMain />} />}
                {HasPermission(user, "man") && <Route path="overview/:id" element={<ManufacturerOverview />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default RouterManufacturers;